import styled from 'styled-components';

const ToggleWrapper = styled.div`
  margin-top: 20px;
`;

export default ToggleWrapper;
